import {
  computeEffectiveStackCostValue,
  getStackTypeTitle,
  selectEnvironmentsByOrgAsList,
  selectStacksByOrgAsList,
} from "@app/deploy";
import { selectStackStats } from "@app/deploy/stats";
import { createSelector } from "@app/fx";
import { schema } from "@app/schema";
import type { DeployStack } from "@app/types";

export interface DeployStackRow extends DeployStack {
  cost: number;
  envCount: number;
  appCount: number;
  dbCount: number;
  typeTitle: string;
}

export const selectStacksForTable = createSelector(
  selectStacksByOrgAsList,
  schema.costs.selectTable,
  schema.costRates.select,
  selectEnvironmentsByOrgAsList,
  selectStackStats,
  (stacks, costs, rates, environments, statsByStack): DeployStackRow[] => {
    return stacks
      .map((stack) => {
        const cost = computeEffectiveStackCostValue(
          costs,
          rates,
          environments,
          stack.id,
        );
        const stackStats = statsByStack[stack.id] || {
          envCount: 0,
          appCount: 0,
          dbCount: 0,
        };
        return {
          ...stack,
          cost,
          ...stackStats,
          typeTitle: getStackTypeTitle(stack),
        };
      })
      .sort((a, b) => b.id.localeCompare(a.id, undefined, { numeric: true }));
  },
);
